import { init as initApm } from '@elastic/apm-rum';

// Extend Window interface to include _env_ property
declare global {
  interface Window {
    _env_: {
      ELASTIC_RUM_enabled?: boolean;
      ELASTIC_RUM_active?: boolean;
      ELASTIC_RUM_serviceName?: string;
      ELASTIC_RUM_serviceVersion?: string;
      ELASTIC_RUM_environment?: string;
      ELASTIC_RUM_breakdownMetrics?: boolean;
      ELASTIC_RUM_serverUrl?: string;
      ELASTIC_RUM_serverUrlPrefix?: string;
      GA?: string;
    };
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

/**
 * Initialize Elastic APM RUM agent
 * This function reads configuration from window._env_ which is loaded from env-config.js
 */
export function initializeAPM(): void {
  // Check if APM is enabled in environment config
  if (!window._env_?.ELASTIC_RUM_enabled || !window._env_?.ELASTIC_RUM_active) {
    console.log('Elastic APM RUM is disabled');
    return;
  }

  try {
    const configuredServerUrl = window._env_.ELASTIC_RUM_serverUrl || 'http://localhost:8200';
    const serverUrl = window.location.hostname.includes('zeta-client') ? configuredServerUrl.replace(/zeta-advisor/g, 'zeta-client') : configuredServerUrl;

    const apmConfig = {
      serviceName: window._env_.ELASTIC_RUM_serviceName || 'zeta-portals',
      serviceVersion: window._env_.ELASTIC_RUM_serviceVersion || '1.0.0',
      environment: window._env_.ELASTIC_RUM_environment || 'development',
      serverUrl,
      serverUrlPrefix: window._env_.ELASTIC_RUM_serverUrlPrefix || '/intake/v2/rum/events',
      breakdownMetrics: window._env_.ELASTIC_RUM_breakdownMetrics || false,
      // Additional configuration for better performance monitoring
      distributedTracingOrigins: [],
      pageLoadTransactionName: window.location.pathname,
      // Disable for development to reduce noise
      active: window._env_.ELASTIC_RUM_active,
    };

    // Initialize APM with the configuration
    initApm(apmConfig);

    console.log('Elastic APM RUM initialized successfully', apmConfig);
  } catch (error) {
    console.error('Failed to initialize Elastic APM RUM:', error);
  }
}

// Export the APM instance if needed for manual transaction tracking
export { apm } from '@elastic/apm-rum';
